import { render, staticRenderFns } from "./ZoneForm.vue?vue&type=template&id=30987dbf&scoped=true&"
import script from "./ZoneForm.vue?vue&type=script&lang=js&"
export * from "./ZoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30987dbf",
  null
  
)

export default component.exports